import * as React from "react";

// style, design
import BaseTable from "src/components/Lists/Base/FinalTable/BaseTable";
import columnDefs from "./listDefs";

// store, state
import { constants } from "../../../store/IMDPriceValue";
import { useFilteredRealEstates } from "../../../store/realEstates";

export default ({
  persistantQuery,
  isBare,
  ignoreLocalStorage,
  tableId,
  onRowClicked,
  checkRowHighlighted,
  onRowSelected,
}) => {
  const [realEstates] = useFilteredRealEstates();

  const columns = React.useMemo(() => {
    const data = columnDefs();
    return data;
  }, [persistantQuery, realEstates]);

  const badges = {};
  const filters = {};

  return (
    <BaseTable
      tableId={tableId || "price_values_full_table"}
      title={"Priser"}
      // onRowClickedWithDetail={(obj) =>
      //   detailUrl({
      //     id: obj.id,
      //   })
      // }
      {...{
        isBare,
        ignoreLocalStorage,
        onRowClicked,
        columns,
        persistantQuery,
        badges,
        filters,
        constants,
        checkRowHighlighted,
        onRowSelected,
      }}
    />
  );
};
